var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("label", { staticClass: "filtro-label-avancado" }, [
      _vm._v("Abrangência"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "btn-group margin-top-10" },
      _vm._l(_vm.buttons, function (button, index) {
        return _c(
          "a",
          {
            key: index,
            staticClass: "btn btn-xs",
            class: _vm.getClass(button.key),
            staticStyle: { margin: "3px" },
            attrs: { href: "javascript:;" },
            on: {
              click: function ($event) {
                return _vm.filterSelected(button.key)
              },
            },
          },
          [_vm._v("\n            " + _vm._s(button.label) + "\n        ")]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }